import React from "react";
import { Card, CardBody, Container } from "reactstrap";
import useRbac from "../Hooks/useRbac";

/**
 * Route-level RBAC guard. Renders `children` only if the current user has
 * at least one of the given permission codes (or is super admin). Otherwise
 * renders a friendly "no access" panel — never blank, never API-thrashing.
 *
 *   <RequirePermission codes={["items.list"]}><ProductsPage /></RequirePermission>
 *
 * `codes` may be a single string for brevity:
 *   <RequirePermission codes="items.list"><...></RequirePermission>
 */
const RequirePermission = ({ codes, children }) => {
  const { isSuperAdmin, canAny } = useRbac();
  const required = Array.isArray(codes) ? codes : codes ? [codes] : [];

  if (isSuperAdmin || required.length === 0 || canAny(required)) {
    return children;
  }

  return (
    <Container fluid className="p-4">
      <Card>
        <CardBody className="text-center py-5">
          <h4 className="mb-2">Access denied</h4>
          <p className="text-muted mb-0">
            You don't have permission to view this page.
            {required.length > 0 && (
              <>
                <br />
                <small>Required: {required.join(" or ")}</small>
              </>
            )}
          </p>
        </CardBody>
      </Card>
    </Container>
  );
};

export default RequirePermission;
